import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'
import { Spinner } from 'components/ui/Spinner'
import clsx from 'clsx'
import { useGetSetting } from 'api/settings'

export type UIButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  loading?: boolean
  color?: string
  className?: string
  negative?: boolean
}

export const UIButton = ({
  children,
  loading,
  color,
  className,
  disabled,
  style,
  negative,
  ...rest
}: UIButtonProps) => {
  const { setting } = useGetSetting()
  return (
    <button
      className={clsx(
        'tw-h-10 tw-p-2 tw-rounded-md tw-text-white tw-flex tw-flex-row tw-items-center tw-justify-center tw-border-2 tw-border-white',
        className,
        disabled && 'tw-opacity-70 tw-cursor-not-allowed',
      )}
      style={
        negative
          ? { color: 'red', borderColor: 'red', borderWidth: 1 }
          : { backgroundColor: color || setting?.primaryColor, ...style }
      }
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <Spinner /> : children}
    </button>
  )
}
